/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    return;
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }
    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());

    // remove protection or free containers
    if (cartSettings.protection_upsell) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        cart.items.forEach(item => {
            if (item.variant_id === cartSettings.protection_upsell.variants[0].id) {
                updatePayload[item.key] = 0;
            }
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerIconsCart').setAttribute("data-count", cart.item_count);

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartHeader").classList.remove("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartUpsell").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // Free shipping for subscription
    if (cartSettings.free_shipping_method === "subscription") {
        if (subscriptionItems > 0) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "YOU'VE UNLOCKED <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "Upgrade to a subscription for <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // Free shipping for price threshold
    if (cartSettings.free_shipping_method === "threshold") {
        let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
        let thresholdText = document.querySelector("#miniCartHeaderBar").dataset.bannerreward;
        let rewardSettings = JSON.parse(document.querySelector("#miniCartHeaderShippingComplete").dataset.settings);
        console.log(rewardSettings);
        if (cart.total_price >= freeShippingThreshold) {
            //show the reward Banner
            document.querySelector("#miniCartHeaderShippingComplete").classList.add("active");
            document.querySelector(".miniCartHeaderShippingCompleteText").innerText = `${rewardSettings.reward_text}`
            //Hide the threshold banner
            document.querySelector("#miniCartHeaderShipping").classList.add("hide");
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = `<b> ${price(freeShippingThreshold - cart.total_price)}</b> away from ${thresholdText}`;
            document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;

            //Show the threshold banner
            document.querySelector("#miniCartHeaderShipping").classList.remove("hide");
            document.querySelector(".miniCartHeaderBarWrapper").classList.remove("hide");
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
            document.querySelector("#miniCartHeaderShippingComplete").classList.remove("active");
        }
    }

    //Update Cart Total and total savings
    console.log(cart);
    document.querySelector(".miniCartFooterSavingsTotalValue").innerText = `${price(cart.total_price)}`
    //IF THE CART HAS DISCOUNTS, SHOW THE SAVE AMOUNT.
    if (cart.total_discount > 0) {
        document.querySelector(".miniCartFooterSavingsSave").classList.add("active");
        document.querySelector(".miniCartFooterSavingsSaveValue").innerText = `${price(cart.total_discount)}`
    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {
        // save supplement data
        const supplementData = cartData[item.key];

        // determine if item has properties
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = price(item.final_line_price);

            // there are 3 types of compare at prices (selling_plan_allocation, line item discount, compare at price)
            // calculate all 3 and the greatest one will be displayed if it is greater than the final line price
            const comparePrices = [];

            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrices.push(item.selling_plan_allocation.compare_at_price * item.quantity);
            }

            // check for line item discount
            if (item.original_line_price > item.final_line_price) {
                comparePrices.push(item.original_line_price);
            }

            // check for compare at price
            if (supplementData.compare_at_price) {
                comparePrices.push(supplementData.compare_at_price * item.quantity);
            }

            // if there is at least one compare price
            if (comparePrices.length > 0) {
                // find the greatest compare price
                const greatestComparePrice = Math.max(...comparePrices);

                // check if the greatest compare price is greater than the final line price
                HTML += `
                        <s>${price(greatestComparePrice)}</s>
                    `;
                //<span>(Save ${price(greatestComparePrice - item.final_line_price)})</span>

            }

            return HTML;
        }

        // upgrade button HTML
        function upgradeHTML() {

            // check if already a subscription
            if (item.selling_plan_allocation) {
                return "";
            }

            // check if selling plan exists
            if (!supplementData["selling_plan_id"]) {
                return "";
            }

            // return HTML
            return `
                <button 
                    class="miniCartBodyItemUpgrade button"
                     data-key="${item.key}"
                     data-quantity="${item.quantity}" 
                     data-plan="${supplementData["selling_plan_id"]}"
                >
               ${supplementData["selling_plan_name"]}
                </button>
            `;
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200" alt="${item.product_title}">
                <div>
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${variantHTML()}
                            ${propertiesHTML()}
                            ${subscriptionHTML()}
                        </div>
                        <div class="miniCartBodyItemPriceWrapper">
                            <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                        </div>
                    </div>
                    <div class="miniCartBodyItemFlex">
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus">-</button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">+</button>
                        </div>
                        <button class="miniCartBodyItemRemove">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_388_6459)">
                                    <path d="M18.518 4.74H1.48297C1.06797 4.74 0.730469 4.4025 0.730469 3.9875C0.730469 3.5725 1.06797 3.235 1.48297 3.235H18.518C18.933 3.235 19.2705 3.5725 19.2705 3.9875C19.2705 4.4025 18.933 4.74 18.518 4.74Z" fill="#333333"/>
                                    <path d="M10.389 19.77H9.61403C6.84403 19.77 5.31903 19.77 4.23403 18.7575C3.15153 17.745 3.04903 16.2225 2.86403 13.4575L2.40403 6.545C2.37653 6.13 2.68903 5.7725 3.10403 5.745C3.51903 5.7175 3.87653 6.03 3.90403 6.445L4.36403 13.3575C4.52903 15.8175 4.61153 17.0525 5.26153 17.66C5.91153 18.2675 7.14903 18.2675 9.61403 18.2675H10.389C12.854 18.2675 14.0915 18.2675 14.7415 17.66C15.3915 17.0525 15.474 15.8175 15.639 13.3575L16.099 6.445C16.1265 6.03 16.4865 5.7175 16.899 5.745C17.314 5.7725 17.6265 6.13 17.599 6.545L17.139 13.4575C16.954 16.2225 16.854 17.745 15.769 18.7575C14.6865 19.77 13.159 19.77 10.389 19.77Z" fill="#333333"/>
                                    <path d="M7.99367 14.76C7.61117 14.76 7.28617 14.47 7.24617 14.0825L6.74617 9.0725C6.70367 8.66 7.00617 8.29 7.41867 8.25C7.83117 8.2075 8.20117 8.51 8.24117 8.9225L8.74117 13.9325C8.78367 14.345 8.48117 14.715 8.06867 14.755C8.04367 14.7575 8.01867 14.76 7.99367 14.76Z" fill="#333333"/>
                                    <path d="M12.0054 14.76C11.9804 14.76 11.9554 14.76 11.9304 14.755C11.5179 14.7125 11.2154 14.345 11.2579 13.9325L11.7579 8.9225C11.8004 8.51 12.1679 8.2075 12.5804 8.25C12.9929 8.2925 13.2954 8.66 13.2529 9.0725L12.7529 14.0825C12.7129 14.47 12.3879 14.76 12.0054 14.76Z" fill="#333333"/>
                                    <path d="M15.5122 4.74C15.4472 4.74 15.4147 4.74 15.3847 4.74C14.8272 4.725 14.2947 4.5475 13.8422 4.22C13.3897 3.895 13.0522 3.445 12.8622 2.9225C12.8522 2.895 12.8422 2.8625 12.8197 2.8L12.7222 2.5075C12.6572 2.315 12.6172 2.19 12.5897 2.1375C12.4797 1.9275 12.2747 1.78 12.0422 1.7425C11.9822 1.7325 11.8497 1.7325 11.6497 1.7325H8.35469C8.15219 1.7325 8.01969 1.7325 7.96219 1.7425C7.72719 1.78 7.52469 1.9275 7.41469 2.1375C7.38719 2.19 7.34469 2.3175 7.28219 2.5075L7.18469 2.8C7.16469 2.8625 7.15219 2.8925 7.14219 2.9225C6.95219 3.445 6.61469 3.895 6.16219 4.22C5.70969 4.545 5.17719 4.725 4.61969 4.74C4.58969 4.74 4.55719 4.74 4.49219 4.74V3.2375C4.53719 3.2375 4.56219 3.2375 4.58219 3.2375C5.10219 3.225 5.55219 2.9 5.72719 2.4125C5.73469 2.3925 5.74219 2.37 5.75719 2.3275L5.85469 2.035C5.94719 1.7575 5.99719 1.605 6.07969 1.445C6.40719 0.814998 7.02219 0.372498 7.72469 0.259998C7.90219 0.232498 8.06219 0.232498 8.35469 0.232498H11.6497C11.9422 0.232498 12.1022 0.232498 12.2797 0.259998C12.9822 0.372498 13.5947 0.814998 13.9247 1.445C14.0072 1.6025 14.0572 1.755 14.1497 2.0325L14.2472 2.3275C14.2622 2.3725 14.2697 2.3925 14.2772 2.4125C14.4547 2.9 14.9047 3.225 15.4222 3.2375C15.4422 3.2375 15.4672 3.2375 15.5122 3.2375V4.74Z" fill="#333333"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_388_6459">
                                        <rect width="20" height="20" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        `);

    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [key]: quantity
                }
            });

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const quantity = parseInt(this.dataset.quantity);
            const sellingPlanID = parseInt(this.dataset.plan);

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // add selling plan
            cart = await changeCart({
                id: key,
                quantity: quantity,
                selling_plan: sellingPlanID
            });

            await openCart(true);

            // remove loading animation
            this.classList.remove("loading");
        });
    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector("#miniCartUpsell").classList.remove("active");
    }
}

// Add Upsell function
document.querySelectorAll('.miniCartUpsellItemWrapATC').forEach(function (element) {
    element.addEventListener("click", async function () {
        // get variant ID from dropdown selector
        const variantID = this.closest('.miniCartUpsellItem').dataset.variant;

        // start loading animation
        document.querySelector("#miniCartContent").classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // check for selling plan
        if (this.closest('.miniCartUpsellItem').dataset.plan) {
            let sellingPlanID = this.closest('.miniCartUpsellItem').dataset.plan;
            formData = {
                items: [{
                    quantity: 1,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            };
        }

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        await openCart();
    });
});


// listen for protection plan switch
document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.addEventListener("change", async function () {
    await openCart(true);
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        // open the kaching cart
        window.kachingCartApi.openCart();
        // openCart();
    });
});

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // check if protection product is checked - if so atc
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        // add protection product
        formData.items.push({
            quantity: 1,
            id: cartSettings.protection_upsell.variants[0].id,
        });
    }

    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}

// COUNTDOWN TIMER
document.querySelectorAll(".miniCartHeaderTimer").forEach(async timer => {
    //pull in the end date from the section settings
    const settings = JSON.parse(timer.dataset.json);
    let targetDate = new Date(settings.year, settings.month - 1, settings.day);
    let currentDate = new Date();
    let dif = targetDate - currentDate;

    //Hide the banner if the date has passed
    if (dif < 0) {
        timer.classList.remove("active");
    }
    await new Promise(resolve => setTimeout(resolve, 1000));
    // dif is in milliseconds
    let days = Math.floor(dif / 1000 * 60 * 60 * 24);
    let hours = Math.floor((dif % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((dif % (1000 * 60 * 60)) / (1000 * 60));

    //Format the values to have a 0 in the tens place
    if (days < 10) {
        days = `0${days}`;
    }
    if (hours < 10) {
        hours = `0${hours}`;
    }
    if (minutes < 10) {
        minutes = `0${minutes}`;
    }
    //Update the countdown UI (two different looking UI elements. Can be changes through the section settings
    if (settings.min_toggle) {
        // The minutes and hours countdown timer
        timer.querySelector("#minutesAlt .miniCartHeaderTimerAltItemValue").textContent = `${hours} : ${minutes} MINUTES`;
    } else {
        // The day, hour, mintues timer
        timer.querySelector("#days .miniCartHeaderTimerItemValue").textContent = days.toString();
        timer.querySelector("#hours .miniCartHeaderTimerItemValue").textContent = hours.toString();
        timer.querySelector("#minutes .miniCartHeaderTimerItemValue").textContent = minutes.toString();
    }

    timer.classList.add("active");

    // Calculate and update the new time every 1 second.
    setInterval(() => {
        let currentDate = new Date();
        let dif = targetDate - currentDate;
        //Hide the banner if the date has passed
        if (dif < 0) {
            timer.classList.remove("active");
        }
        // dif is in milliseconds
        let days = Math.floor(dif / (1000 * 60 * 60 * 24));
        let hours = Math.floor((dif % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((dif % (1000 * 60 * 60)) / (1000 * 60));

        //Format the values to show a 0 in the tens place
        if (days < 10) {
            days = `0${days}`;
        }
        if (hours < 10) {
            hours = `0${hours}`;
        }
        if (minutes < 10) {
            minutes = `0${minutes}`;
        }

        //Update the countdown UI (two different looking UI elements. Can be changes through the section settings
        if (settings.min_toggle) {
            // The minutes and hours countdown timer
            timer.querySelector("#minutesAlt .miniCartHeaderTimerAltItemValue").textContent = `${hours} : ${minutes} MINUTES`;
        } else {
            // The day, hour, mintues timer
            timer.querySelector("#days .miniCartHeaderTimerItemValue").textContent = days.toString();
            timer.querySelector("#hours .miniCartHeaderTimerItemValue").textContent = hours.toString();
            timer.querySelector("#minutes .miniCartHeaderTimerItemValue").textContent = minutes.toString();
        }
    }, 1000);
})